// extracted by mini-css-extract-plugin
export default {"tangramAnimation":"Tangram-module__tangramAnimation___A4ari"};